import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ArrowBack as BackIcon } from '@material-ui/icons';
import {
  Box,
  Container,
  Grid,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 0),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0, 0, 10, 10)
  },
  actionNeeded: {
    marginLeft: '20px !important',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    color: theme.palette.text.secondary.main,
  },
  badgeIcon: {
    marginRight: theme.spacing(1)
  },
  openStatus: {
    marginRight: -2,
    color: '#007913',
    backgroundColor: '#D4F9DC'
  },
  closedStatus: {
    marginRight: -2,
    color: '#D4EEF9',
    backgroundColor: 'rgb(0, 155, 218, 0.17)'
  },
  status: {
    marginLeft: theme.spacing(6)
  },
  statusIcon: {
    borderRadius: theme.spacing(2),
    marginLeft: theme.spacing(5)
  },
  loadingIcon: {
    marginRight: theme.spacing(1),
    borderRadius: theme.spacing(1)
  },
  firstGridItem: {
    display: 'flex',
    alignItems: 'center'
  },
  mobileDisplay: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(6.5)
  },
  [theme.breakpoints.up(992)]: {
    mobileDisplay: {
      display: 'none'
    }
  },
  [theme.breakpoints.down(992)]: {
    approvedAmount: {
      display: 'none'
    },
    amountRequested: {
      display: 'none'
    },
    dateOfLoss: {
      display: 'none'
    }
  },
}));

function HeaderSkeleton({ className, onGoBack, ...rest }) {
  const classes = useStyles();

  return (
    <Grid
      container
      className={clsx(classes.root, className)}
      direction="row"
      {...rest}
    >
      <Container maxWidth="lg" component="section">
        <Box
          display="flex"
          alignItems="center"
          color="text.secondary"
          width="100%"
        >
          <Grid item xs={3} className={classes.firstGridItem}>
            <IconButton
              onClick={onGoBack}
              edge="start"
            >
              <BackIcon />
            </IconButton>
            <Skeleton
              className={classes.statusIcon}
              variant="rect"
              height={30}
              width={70}
            />
          </Grid>
          <Grid item xs={3}>
            <div className={clsx(classes.badge, classes.dateOfLoss)}>
              <Skeleton className={classes.loadingIcon} variant="rect" width={30} height={25} />
              <Skeleton variant="text" width={100} height={40} />
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={clsx(classes.badge, classes.approvedAmount)}>
              <Skeleton className={classes.loadingIcon} variant="rect" width={30} height={25} />
              <Skeleton variant="text" width={100} height={40} />
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={clsx(classes.badge, classes.amountRequested)}>
              <Skeleton className={classes.loadingIcon} variant="rect" width={30} height={25} />
              <Skeleton variant="text" width={100} height={40} />
            </div>
          </Grid>
        </Box>
        <Grid
          container
          direction="row"
          spacing={4}
          alignItems="center"
          className={classes.mobileDisplay}
        >
          <Grid item xs={2} align="center">
            <Skeleton variant="text" width={40} height={40} />
            <Skeleton variant="text" width={100} height={40} />
            <Skeleton variant="text" width={100} height={40} />
          </Grid>
          <Grid item xs={2} align="center">
            <Skeleton variant="text" width={40} height={40} />
            <Skeleton variant="text" width={100} height={40} />
            <Skeleton variant="text" width={100} height={40} />
          </Grid>
          <Grid item xs={2} align="center">
            <Skeleton variant="text" width={40} height={40} />
            <Skeleton variant="text" width={100} height={40} />
            <Skeleton variant="text" width={100} height={40} />
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

HeaderSkeleton.propTypes = {
  className: PropTypes.string,
  claim: PropTypes.object.isRequired,
  onGoBack: PropTypes.func
};

HeaderSkeleton.defaultProps = {
  onGoBack: () => { }
};

export default HeaderSkeleton;
